'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ToggleEntry = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _ToggleEntry = require('./ToggleEntry.less');

var _ToggleEntry2 = _interopRequireDefault(_ToggleEntry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ToggleEntry = exports.ToggleEntry = function (_Component) {
	_inherits(ToggleEntry, _Component);

	function ToggleEntry(props) {
		_classCallCheck(this, ToggleEntry);

		var _this = _possibleConstructorReturn(this, (ToggleEntry.__proto__ || Object.getPrototypeOf(ToggleEntry)).call(this));

		_initialiseProps.call(_this);

		_this.state.active = props.active || false;
		return _this;
	}

	_createClass(ToggleEntry, [{
		key: 'render',
		value: function render() {
			return React.createElement(
				'li',
				{ className: _ToggleEntry2.default.toggleEntry },
				React.createElement(
					'a',
					{ className: _ToggleEntry2.default['checkbox-holder'], onClick: this.onClick },
					React.createElement('input', { id: this.getCheckBoxId(), type: 'checkbox',
						checked: this.state.active,
						className: 'checkbox',
						readOnly: true }),
					React.createElement(
						'label',
						{
							htmlFor: this.getCheckBoxId() },
						this.props.children
					)
				)
			);
		}
	}]);

	return ToggleEntry;
}(_react.Component);

ToggleEntry.idCounter = 0;

var _initialiseProps = function _initialiseProps() {
	var _this2 = this;

	this._id = null;
	this.state = {
		active: false
	};

	this.getCheckBoxId = function () {
		if (!_this2._id) {
			_this2._id = _this2.props.id || '__checkbox_' + ++ToggleEntry.idCounter;
		}
		return _this2._id;
	};

	this.onClick = function (e) {
		e.preventDefault();
		var active = !_this2.state.active;
		_this2.setState({ active: active });
		if (_this2.props.onChange) {
			_this2.props.onChange(active);
		}
	};

	this.componentWillReceiveProps = function (props) {
		if (props.active != _this2.state.active) {
			_this2.setState({ active: props.active });
		}
	};
};


//////////////////
// WEBPACK FOOTER
// ./js/Components/ToggleEntry.js
// module id = 304
// module chunks = 0